export default __webpack_public_path__ + "bcf47dea05fb15e3c8cf6adbca9465be.svg";